import * as ActionTypes from '../components/actions/types';

function stepReducer(
  state = {
    showDashboard: false,
    showProfile: false
  },
  action,
) {
  switch (action.type) {
    case ActionTypes.SET_STEPS:
      return {
        ...state,
        list: action.payload
      };
    case ActionTypes.RESET_INTRO:
      return {
        ...state,
        showDashboard: true,
        showProfile: true
      };
    case ActionTypes.VIEWED_DASHBOARD:
      return {
        ...state,
        showDashboard: false
      };
    case ActionTypes.VIEWED_PROFILE:
      return {
        ...state,
        showProfile: false
      };
    default: {
      return state;
    }
  }
}

export default stepReducer;



// WEBPACK FOOTER //
// ./src/reducers/steps.js